import { render, staticRenderFns } from "./RunVersionChips.vue?vue&type=template&id=88497096&scoped=true"
import script from "./RunVersionChips.vue?vue&type=script&lang=js"
export * from "./RunVersionChips.vue?vue&type=script&lang=js"
import style0 from "./RunVersionChips.vue?vue&type=style&index=0&id=88497096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88497096",
  null
  
)

export default component.exports